import { useSelector } from 'react-redux';
import { blockPlayForFunSelector } from '~/components/casino-shared/ducks/selectors';

const useIsFunModeAllowed = (game: { hasFunMode?: boolean } | undefined | null) => {
	const hasFunMode = !!game?.hasFunMode;
	const blockPlayForFun = useSelector(blockPlayForFunSelector);

	return !blockPlayForFun && hasFunMode;
};

export default useIsFunModeAllowed;
